import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";

import { getDeals } from "api/requests/getDeals";
import { Deal } from "custom-types/Deals";
import useDomainCountryCode from "hooks/useDomainCountryCode";
import { getCoordinates } from "redux/selectors/location";

const DealsCarousel = dynamic(() => import("components/Shared/DealsCarousel"));

const ShopDealsCarousel: React.FC = () => {
  const [deals, setDeals] = useState<Deal[]>();

  const coordinates = useSelector(getCoordinates);
  const countryCode = useDomainCountryCode();

  useEffect(() => {
    getDeals(coordinates, countryCode, 0, 8).then(({ deals }) =>
      setDeals(deals)
    );
  }, [coordinates]);

  if (deals === undefined || deals.length === 0) {
    return null;
  }

  return <DealsCarousel deals={deals} className="my-section" />;
};

export default ShopDealsCarousel;
